import { Col, Layout, Row } from 'antd'
import RegistrationForm from '../components/Authentication/RegistrationForm'
import { gutter } from '../lib/layout'
import styles from '../less/BaseLayout.module.less'
import useDocumentTitle from '../lib/useDocumentTitle'
import { useTranslation } from 'react-i18next'
import { useLogo } from '../lib/themeController'

export default function SignUpPage({ emailSignup, googleSignup }) {
  const { t } = useTranslation()
  const logoBlack = useLogo('bw')
  useDocumentTitle(t('frontend:auth.signupPageTitle'))

  return (
    <Layout style={{ margin: '50px 8px' }}>
      <Row gutter={gutter} type="flex" justify="center" align="middle">
        <Col align="center" xs={24} style={{ maxWidth: '450px' }}>
          <img
            src={logoBlack}
            alt="cleverlohn"
            className={styles.logo}
            style={{ marginBottom: '25px' }}
          />

          <RegistrationForm
            emailSignup={emailSignup}
            googleSignup={googleSignup}
          />
        </Col>
      </Row>
    </Layout>
  )
}
